const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
export const SITE_TIME_ZONE = "America/New_York";

export const parseEventDate = (dateOnly: string) => {
  const match = DATE_ONLY_PATTERN.exec(dateOnly);
  if (!match) return new Date(dateOnly);

  const [, year, month, day] = match;
  return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), 12));
};

export const toSiteDateOnly = (date = new Date()) => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: SITE_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
  return `${values.year}-${values.month}-${values.day}`;
};

export const isEventPast = (dateOnly: string, now = new Date()) =>
  DATE_ONLY_PATTERN.test(dateOnly)
    ? dateOnly < toSiteDateOnly(now)
    : parseEventDate(dateOnly).getTime() < now.getTime();

export const eventDateTimestamp = (dateOnly: string) => {
  const match = DATE_ONLY_PATTERN.exec(dateOnly);
  if (!match) return parseEventDate(dateOnly).getTime();
  const [, year, month, day] = match;
  return Date.UTC(Number(year), Number(month) - 1, Number(day));
};

export const formatEventDate = (
  dateOnly: string,
  locales?: Intl.LocalesArgument,
  options?: Intl.DateTimeFormatOptions
) =>
  new Intl.DateTimeFormat(locales, { ...options, timeZone: "UTC" }).format(
    parseEventDate(dateOnly)
  );
